"use strict";
exports.differenceInSeconds = differenceInSeconds;
var _index = require("./_lib/getRoundingMethod.js");
var _index2 = require("./differenceInMilliseconds.js");
function differenceInSeconds(dateLeft, dateRight, options) {
  const diff = (0, _index2.differenceInMilliseconds)(dateLeft, dateRight) / 1e3;
  return (0, _index.getRoundingMethod)(options == null ? void 0 : options.roundingMethod)(diff);
}
